<template>
    <v-autocomplete
        v-model="autocomplete_model"
        :items="autocomplete_entries"
        :loading="autocomplete_isLoading"
        :search-input.sync="autocomplete_search"
        color="info"
        hide-no-data
        item-text="username"
        item-value="id"
        :label="setManagerSupervisorName()"
        solo
        single-line
        dense
        clearable
        :return-object="true"
        :error-messages="formerror.field"
    ></v-autocomplete>
</template>

<script>
    export default {
        data(){
            return{
                autocomplete_entries: [],
                autocomplete_isLoading: false,
                autocomplete_model: [],
                autocomplete_search: '',
                formerror: {},
                isUpdateSearch: '',
            };
        },
        methods:{
            setManagerSupervisorName(){
                console.log(1);
                if(this.$store.state.currentUser.agent_data.level == 0){
                    return 'Manager';
                }
                else if(this.$store.state.currentUser.agent_data.level == 1){
                    return 'Supervisor';
                }
                else if(this.$store.state.currentUser.agent_data.level == 2){
                    return 'Supervisor';
                }
                else{
                    return 'Manager';
                }
            },
            isupdatesearch(data){
                this.getdata(data, true);
            },
            errorwatcher(data){
                if(data == "error"){
                    this.formerror['field'] = 'This field is required.';
                    this.autocomplete_search = '';
                }else{
                    this.formerror = {};
                }
            },
            getdata(val, isautosearch = false){
                this.formerror['reload']++;
                this.autocomplete_isLoading = true;
                this.$axios.post( this.$_CONFIG.api('API_SEARCH_AGENT'), {sub_agent: val } )
                .then(res => {
                    this.autocomplete_entries = res.data;

                    if(isautosearch){
                        this.autocomplete_model = this.autocomplete_entries[0];
                    }
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.autocomplete_isLoading = false))
            }
        },
        computed: {
            
        },
        watch: {
            // autocomplete_model(val, oldval) {
                // this.form.employee_id = val.id;
                // console.log(val);
                // return val.id;
            // },
            // formerror(){
            //     this.formerror.player_id = this.formerror.player_id;
            // },
            autocomplete_search (val) {
                this.getdata(val);
                // this.formerror['reload']++;
                // this.autocomplete_isLoading = true;
                // this.$axios.post( this.$_CONFIG.api('API_SEARCH_AGENT'), {sub_agent: val } )
                // .then(res => {
                //     this.autocomplete_entries = res.data;
                // })
                // .catch(err => {
                //     console.log(err)
                // })
                // .finally(() => (this.autocomplete_isLoading = false))
            },
        },
        created(){
            
        },
        mounted() {

        }
    }
</script>
